module.exports = __webpack_public_path__ + "f0891a809bf10877a86c4d5c11387a5b.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1084
// module chunks = 0